<template>
<q-scroll-area style="height: calc(100vh - 50px) !important">
  <q-page fluid>

    <div class="row full-width">
      <div class="col-12">
        <q-card class="full-width">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                 Table of contents
              </div>

              <q-space />
              <q-toggle
        v-if="apiUrl != 'https://api.flexi-comms.com'"
        v-model="apiUrlSelection"
        :label="`${apiUrlSelection ? 'Dev Site' : 'Live Site'}`"
        ></q-toggle>
            </div>
          </q-card-section>

          <q-separator />


          <q-card-section>
            <q-tree
          :nodes="itemsAdmin"
          node-key="name"
          label-key="name"
          :selected.sync="selected"
          v-if="currentUserData.role == 'superAdmin'"
        >
        </q-tree>
        <q-tree
        :nodes="items"
          node-key="name"
          label-key="name"
          :selected.sync="selected"
          v-if="currentUserData.role != 'superAdmin'"

        >

        </q-tree>
          </q-card-section>
        </q-card>
      </div>
      <div
        class="col-12 q-mt-md"
      >
        <!-- Application Specs -->
        <q-card class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                  Applications
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeviceDialog = true" /> -->
          <q-card-section>
            <div id="applicationAbout" style="display: inline-block" class="text-h6">What is an Application?</div>
            <p>
              An Application is a white labeled system that is running on the Flexi-comms stack. Applications contain organizations and own devices, an example of an application would be Flexi-comms, Critterpic, Christchurch City Counsel. <br />
              Applications have their own URL which need to be implemented manually by Simple Software, and are only manageable by Super Admins. The data for applications (Like Devices, Deployments, events etc.) are part of the Application and cannot leave the application. <br />
              Applications can have organisations under them, that allow users to log into their system, and manage the devices, for example, Christchurch City Counsel might have have UC (University of Canterbury) setup as an organisation and have devices set up for them.
            </p>
            <div id="applicationCreation" style="display: inline-block" class="text-h6">Creating an Application</div>
            <p>
              To create an Application there are a few steps.
              <ol>
                <li>First you have to Create the Application using the "Applications" interface on Flexi-comms Website</li>
                <li>For Now you will need to contact Simple Software to set up the rest, aswell as the domains. This is because Oauth (Google Signin),
                  Auth0(Credentials Manager), Amplify (Front end Hosting) and Route53 need to be set up with the Applications Domain.
                </li>
              </ol>
            </p>
            <div style="display: inline-block" class="text-h6" id="applicationManagement">Managing an Application</div>
            <p>
              To manage an application, you can do this through the Applications interface. If you wish to change the domain, you will need to contact Simple software.
            </p>
          </q-card-section>
        </q-card>
        <!-- Organizations Specs -->
        <q-card class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                  Organizations
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeviceDialog = true" /> -->
          <q-card-section>
            <div id="organizationAbout" style="display: inline-block" class="text-h6">What is an Organization?</div>
            <p>
              An Organisation is an Entity that is a part of an Application. Organisations will be given ownership of devices by Application Admins, and will be able to setup Deployments for the devices to manage event permissions. <br />
              Organisations have Org Admins, and Org Users. Org admins have access to create deployments, and add users whereas Org users only have access to view events and devices part of a deployment they have been granted access to.
            </p>
            <div id="organizationCreation" style="display: inline-block" class="text-h6">Creating an Organization</div>
            <p>
              To create an Organization, use the Organizations interface. You will need a Name for the Organization, and an Application to assign the Organization to.
            </p>
            <div style="display: inline-block" class="text-h6" id="organizationnManagement">Managing an Organization</div>
            <p>
              To manage an Organization, you can do this through the Organizations interface. You will not be able to move an Organization to another Application, but you can change its name.
            </p>
          </q-card-section>
        </q-card>
        <!-- Device Specs -->
        <q-card class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                  Devices
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <div id="deviceCreation" style="display: inline-block" class="text-h6">Creating a Device</div>
            <p>
              To create a Device, use the Device interface. You will need to know the application the device is a part of. If the device has a parent then you will need to know the parent device's ID aswell.
            </p>
            <div id="deviceCreationMultiple" style="display: inline-block" class="text-h6">Creating Multiple Devices with a CSV</div>
            <p>
              To create multiple devices with a CSV, you will need to use these fields below, then upload the csv through the Device Interface.
              <ul>
                <li>applications_id (INT) * Required</li>
                <li>pcb_id (String)</li>
                <li>version (String)</li>
                <li>sim (String)</li>
                <li>comment (String)</li>
                <li>parentKey (String)</li>
                <li>isHub (INT, 1 for True, 0 for False) </li>
              </ul>
            </p>
            <div  style="display: inline-block" class="text-h6" id="deviceManagement">Managing the Device</div>
            <p>
              To manage a device you double click on the row. This will bring up a menu of options.
              In this menu you will be able to edit certain information for the Device. This information does not need to be stored on the device.
            </p>
            <div id="deviceKeyRegen" style="display: inline-block" class="text-h6">Regenerating the Device Key</div>
            <p>
              To regenerate the device key you are going to need to double
              click the row of the device. Once in the menu, you should see a button "Re-generate Key". Clicking on this
              will generate a new Key for the device. After this, you must update the Key manually on your device, as the old
              Key will be invalid.
            </p>
            <div id="ownershipAbout" style="display: inline-block" class="text-h6">What is an Ownership?</div>
            <p>
              An Ownership is what assigns a Device to an Organization. This will allow the Organization to setup Deployments for Devices.
            </p>
            <div id="ownershipCreation" style="display: inline-block" class="text-h6">Creating an Ownership</div>
            <p>
              To create an Ownership, use the Ownership interface. You will need to know the Organization and Device ID.
            </p>
            <div style="display: inline-block" class="text-h6" id="ownershipManagement">Ending an Ownership</div>
            <p>
              To End an Ownership, Double click on the ownership you wish to end, then select click the "End Ownership" button. (This will end a Deployment that is associated with that ownership)
            </p>
            <div id="deploymentAbout" style="display: inline-block" class="text-h6">What is a Deployment?</div>
            <p>
              A Deployment is a period in time where All requests from a device will be associated with the Deployment.
              This is used to Groups events together, and allow you to assign users to a specific deployment.
              You can also assign a User to past deployments so they can view events from the past.
            </p>
            <div id="deploymentCreation" style="display: inline-block" class="text-h6">Creating an Deployment</div>
            <p>
              To create a Deployment, use the Deployment interface. You will need to know the organization the device is a part of, the device ID, and have a name for the deployment.
            </p>
            <div style="display: inline-block" class="text-h6" id="deploymentManagement">Ending an Deployment</div>
            <p>
              To End a deployment, double click on the deployment you wish to end, and click on "End Deployment".
            </p>



            <div  style="display: inline-block" class="text-h6" id="deviceComSpec">Device Communication Spec</div>
            <div  style="display: inline-block" class="text-h6">ID and K</div>
            <p>
              On device creation you will be given a device_id which you will add into the device as ID, this has to be sent with every request to the API.
              You will also be given k, which is the Device Key that was generated for your device, this will also need to be sent with every request to the API.
            </p>
            <div  style="display: inline-block" class="text-h6">Endpoint to create event</div>
            <p>
              <span v-if="currentUserData.role == 'superAdmin'">
                <span style="font-weight: 700">Dev Site URL:</span> <pre>https://flexi-comms-api.simplesoftware.nz/events</pre>
              </span>
              <br />
              <span style="font-weight: 700">
                <span v-if="currentUserData.role == 'superAdmin'">Live Site</span> URL:
              </span> <pre>https://api.flexi-comms.com/events</pre>
              <br />
              <span style="font-weight: 700">Method:</span> POST
              <br />Data is to be sent through as JSON in the Body
            </p>
            <div  style="display: inline-block" class="text-h6">Data Format to be sent to API</div>
            <p>
              The data to be sent to the API must be sent in JSON. All fields that are sent through, that are not part of the JSON demonstration below
              will be added to an Extended Data Field. The required fields are id, type.
            </p>
            <vue-json-pretty :data="eventDataFormat" :highlightMouseoverNode="true" :showLength="true"></vue-json-pretty>
            <p>The Response from the server if successful</p>
            <vue-json-pretty
              :data="{'Result': 'Success', 'events_id': '1111'}"
              :highlightMouseoverNode="true"
              :showLength="true"
            ></vue-json-pretty>
            <div  style="display: inline-block" class="text-h6">Event Versions (v)</div>
            <p>
              There are currently two event versions supported by Flexi-comms. Those are "cp" and "f", and how the data from these are handled are very different from each other.
              The most basic one is "cp", which just accepts data as on object, and then stitches either the Image or Data field sent through if the type "trigger" was sent along with it. Whereas "f", is a bit more complicated. <br />
              Events with the v set to "f", will be treated as a string, that needs to be re-assembled at a later stage once all events have come through. Then once all events have arrived, then server will build the whole event and process it as a normal event. <br />
              By default the v is set to "cp".
            </p>
            <div  style="display: inline-block" class="text-h6">Rockblock Devices</div>
            <p>
              Rockblock devices are handled completely differently. They are are part of "Hubs and Chains", listed below. The data sent from a Rockblock device will be docoded and entered into the database as an event IF a value was different from its last communication with flexi-comms (Except for Hubs, their data is always entered into the Database) <br />
              Please contact Redfern or Simple Software for the Rockblock packet Format.
            </p>
            <div  style="display: inline-block" class="text-h6 q-mt-md" id="deviceHubAndChains">Hubs and Chains</div>
            <p>
              A Device has the option to be set as a Hub for a Chain by selecting the "Is a Hub" checkbox on the Device popup.
            </p>
            <p>
              For a Chain to be created from a hub, the Hub device needs to be set to hub first, then you will have a "Chains" tab at the top appear. <br />
              Head into the Chains tab and you will have a table with all of the chains associated with that specific "Hub/Device". If you click the "Add" button, you will be able to
              create a new Chain from that Hub. You will need to give it a Descriptor and a Position (Please note that the Positions are unique and cannot be the same as a previous Chains Pos). <br />
              Once a Chain has been created, if you double click on the chain, you will have access to edit the Chains position, Descriptor and to Add/Remove Devices from the chain. <br /> <br />
              To Add a device to the Chain, you will need to enter the Devices ID into the search box and select the device you with to add, then click the "Add" Button. <br />
              To Remove a Device from a Chain, you will need to find the Device in the table at the bottom, and click the trash icon. <br />
              To Edit the position of the device in the chain, you will need to Type it into the "Chain Position" textbox that is situated in each Device row in the table at the bottom. Once you have typed in a new value, when you click out of the text box, it will automatically save.
            </p>
            <div  style="display: inline-block" class="text-h6 q-mt-md" id="deviceTypeAbout">Device Types</div>
            <br />
            <div  style="display: inline-block" class="text-h6 q-mt-md">What are Device Types</div>
            <p>
              A Device Type is a way to give certain settings to multiple devices based on its type. These settings include a Battery Threshold, Heartbeat timeout, and how Data is displayed. <br />
              Device Types are part of an Application, and are given a name to be accessed. They also have a Type and Type set value, these two field are used to determine how the data should be displayed. E.g. a device type "Flexi-comms" with a type set "Trap (rb)", will be a Rockblock Device type designed by Flexicomms.
              This will determine how the data is displayed on the events table, as well as how it is handled throughout the site. <br />
              Below are the available Device Types
            </p>

            <ul>
              <li>
                Critterpic
                <ul style="padding-left: 1em">
                  <li>
                    Picture - On the events table, the relevant data column will display the Last Message Received timestamp.
                  </li>
                </ul>
              </li>
              <li>
                Flexi-comms
                <ul style="padding-left: 1em">
                  <li>
                    Trap - On the events table, the relevant data column will display the traps property sent to the server I.E [0, 0]
                  </li>
                  <li>
                    Trap (rb) - On the events table, the relevant data column will display the Current Triggered status of the trap, I.E "Un-Triggered", "Trap 1 Triggered", "Trap 2 Triggered", "Both Traps Triggered"
                  </li>
                </ul>

              </li>
            </ul>
            <div  style="display: inline-block" class="text-h6 q-mt-md" id="deviceTypeCreation">Creating a Device Type</div>
            <p>
              To create a Device Type, use the Device Type interface. You will need to know the what type of device it is, what the Battery threshold will be and what the Heartbeat threshold will be.
            </p>
            <div  style="display: inline-block" class="text-h6 q-mt-md" id="deviceTypeManagement">Managing a Device Type</div>
            <p>
              To manage a Device Type, use the Device Type interface, double click on the device type you wish to manage, and alter the settings of that device type.
            </p>
            <div  style="display: inline-block" class="text-h6 q-mt-md" id="uiNotifications">Notifications</div>
            <br />
            <div  style="display: inline-block" class="text-h6 q-mt-md">UI Notifications</div>
            <p>
              There are currently no UI notifications for each user, although there are visual queues for when a devices has missed its heartbeat or its battery level is too low. These are found on the Devices table, If the row is Orange, it means that the device has missed its heartbeat, and if the device is red, it means its battery level is too low.
            </p>
            <div  style="display: inline-block" class="text-h6 q-mt-md" id="emailNotifications">Email Notifications</div>
            <p>
              There are different types of notifications for Devices, these will be sent via email (depending on your account settings) either straight away or via a summarized list at 5pm NZ time each day. <br />
              Here is the list of current Notifications
            </p>
            <ul>
              <li><b>Low Battery</b> - When the devices battery level is lower than its threshold</li>
              <li><b>Heartbeat Missed</b> - When a heart beat from a device was not heard in its threshold</li>
              <li><b>Missing Packet Number</b> - When a packet was missing </li>
              <li><b>New Trigger Event</b> - When a Trigger event comes from a device</li>
              <li><b>Rockblock</b> - When an event comes through from a Rockblock device and its data has changed</li>
            </ul>
            <div  style="display: inline-block" class="text-h6 q-mt-md" id="deviceStatuses">Device Status's</div>
            <p>
              The Device Status UI displays the current status of different traps in Flexi-comms. It has an orange colour if at-least one trap is triggered, and a gray colour if no traps are triggered. It will also display the date that the device last changed its status.
            </p>
            <div  style="display: inline-block" class="text-h6 q-mt-md" id="deviceMap">Device Map</div>
            <p>
              The Device Map UI is used to display Devices last known locations, as well as a colour indicator on its marker to indicate when the last message was received from the device. Here are the colours below
            </p>
            <ul>
              <li>
                <b>Red</b> - Last event was received within the last Hour
              </li>
              <li>
                <b>Orange</b> - Last event was received within the 2 Hours
              </li>
              <li>
                <b>Green</b> - Last event was received within the 24 Hours
              </li>
              <li>
                <b>Dark Gray</b> - Last event was received more than 24 Hours ago
              </li>
            </ul>
            <p>Clicking on a market will bring up relevant information about that device on the right hand side of the map, and you also have a filter button on the left hand side that will allow you to filter what devices are displayed on the map</p>

          </q-card-section>
        </q-card>

      <!-- Event Specs -->
        <q-card class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Event Specs
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeviceDialog = true" /> -->
          <q-card-section>
            <div  style="display: inline-block" class="text-h6" id="eventDataWebsite">Event data (Via Website)</div>
            <p>
              To view event data via the website, you need to click on either "All Events" or "Trigger Events".
              <br />All events will have a table with all of the events in the current Date range which is set in the toolbar.
              <br />Trigger events will have the files that were sent through with the events that have their status set to "trigger".
            </p>
            <div v-if="currentUserData.role == 'superAdmin'">
              <div  style="display: inline-block" class="text-h6" id="eventDataAPI">Event data (Via API)</div>
              <p>
                This is currently only available for Super Admins. To access the event data via the API, you must have your API Key, and the App ID.
                <br />The Api Key is a randomly generated GUID that identifies a User, So this must be kept Secret. At this time API Keys are Generated manually
                by the Developers, but a system to have this generated automatically is underway.
                <br />The App ID is the ID of the application in which you are requesting the data for, If your are a Super Admin, this is Bypassed but an App ID
                will still need to be sent through (e.g. 10)
                <br />The API Key and APP ID will both need to be sent through in the headers. The Keys for the Headers are Apikey, Appid.
                <br />You also need to send through a date range as parameters on the end of the URL. The format for this is as Follows
                <br />
                <br /> <pre>dateRange[]=2020-08-14&dateRange[]=2020-07-15</pre>
                <br />Optionally you can also send through the type as a Parameter e.g. type=trigger.
                <br />
                <br />The URL for the endpoint is The same as creating an Event, but instead using the GET Method
                <br />A full endpoint for trigger events withing a specific Date Range would be
                <br />
                <pre>{{apiUrlSelection ? apiUrl : 'https://api.flexi-comms.com'}}/events?dateRange[]=2020-08-14&dateRange[]=2020-07-15&type=trigger</pre>
              </p>
            </div>
            <div v-if="currentUserData.role == 'superAdmin'">
              <div  style="display: inline-block" class="text-h6" id="eventImagesFromS3">Event Images</div>
              <p>
                If you have gotten the event data from the API, to be able to get the Images, you will need to request them from S3.
                To do this you will need to need to generate the Url to get these images. The URL is made up of three peices, the S3 bucket,
                event ID and the file extension. The code example should look like this
                <br>
                <pre>https://{bucket}.s3.ap-southeast-2.amazonaws.com/{event.id}-triggerEvent.{event.fileType}</pre>
                <br>
                An example of a functioning URL will look like this
                <pre>https://flexi-comms-trigger-events.s3.ap-southeast-2.amazonaws.com/27612-triggerEvent.jpg</pre>

              </p>
            </div>
            <div v-if="currentUserData.role == 'superAdmin'">
              <div  style="display: inline-block" class="text-h6" id="eventMetaData">Creating Meta Data for an Event (Via API)</div>
              <p>
                The API Call uses the same concept of Api Key and App ID stated above in Event Data (Via API).
                No Parameters need to be sent with the API Call, All that needs to be sent through is the "id" in the Body data, and what ever
                other data you wish to be put into the Meta Data.
                <br />The data needs to be in JSON format, and sent through in the Body, and the Api Key + App ID needs to also be sent through in the header
                <br />The Endpoint to send the request to is the same as creating an Event, but instead using the PUT Method.
                <br />All Data that is sent through will be put into the Meta Data field for the Event exactly how it is sent through.
                <br />
                <br />An example of what to send through
              </p>
              <vue-json-pretty
               :data="eventMetaDataFormat"
               :highlightMouseoverNode="true"
               :showLength="true"
              ></vue-json-pretty>
              <p>An example of a successful response</p>
              <vue-json-pretty
                :data="{'Result': 'Success'}"
                :highlightMouseoverNode="true"
                :showLength="true"
             ></vue-json-pretty>
            </div>
          </q-card-section>
        </q-card>
        <!-- Ownership Specs -->
        <q-card class="q-mb-md" v-if="currentUserData.role == 'superAdmin'">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                  Users
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeviceDialog = true" /> -->
          <q-card-section>
            <div id="userCreation" style="display: inline-block" class="text-h6">Creating a User</div>
            <p>
              To create a User, use the Users interface. You will need to know the Users Email and Name.
            </p>
            <div id="userRoles" style="display: inline-block" class="text-h6">Giving User Roles</div>
            <p>
              To give a user roles, you will need to use the Users interface (For Super Admins). If you are not a super admin, you can assign a User to an Org,
              or a Deployment using the Corresponding interface and double clicking on the Org/Deployment you want to add the user too.
            </p>
            <div id="userImpersonation" style="display: inline-block" class="text-h6">Impersonating a User (Super Admins Only)</div>
            <p>
              To impersonate another user, you will need to use the Users Interface. When you open the user to impersonate, click the impersonate User
              button, and this will have the system act asif you are that user.
            </p>
          </q-card-section>
        </q-card>

        <!-- AWS Specs -->
        <q-card v-if="currentUserData.role == 'superAdmin'" class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                AWS Specs
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeviceDialog = true" /> -->
          <q-card-section>
            <div  style="display: inline-block" class="text-h6" id="awsInstallation">AWS CLI Installation</div>
              <p>
                Aws has their CLI installation process well Documented, To view it
               <a
                 target="_blank"
                 href="https://docs.aws.amazon.com/cli/latest/userguide/cli-chap-install.html"
                >
                click here
                </a>
              </p>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </q-page>
  </q-scroll-area>
</template>

<script>
  import { mapGetters } from "vuex";
  import VueJsonPretty from "vue-json-pretty";

  export default {
    components: { VueJsonPretty },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        apiUrl: "settings/apiUrl",
      }),
      itemsAdmin: function () {
        return [
          {
            name: "Applications",
            icon: "mdi-application",
            admin: true,
            selectable: false,
            children: [
              {
                name: "What is an Application",
                icon: "mdi-help",
                handler: (node) => this.handleNodeClick(node),
                admin: true,
                link: "#applicationAbout",
              },
              {
                name: "Application Creation",
                icon: "mdi-plus",
                handler: (node) => this.handleNodeClick(node),
                admin: true,
                link: "#applicationCreation",
              },
              {
                name: "Application Management",
                icon: "mdi-cogs",
                handler: (node) => this.handleNodeClick(node),
                admin: false,
                link: "#applicationManagement",
              },
            ],
          },
          {
            name: "Organizations",
            icon: "mdi-domain",
            admin: true,
            selectable: false,
            children: [
              {
                name: "What is an Organization",
                icon: "mdi-help",
                handler: (node) => this.handleNodeClick(node),
                admin: true,
                link: "#organizationAbout",
              },
              {
                name: "Organization Creation",
                icon: "mdi-plus",
                handler: (node) => this.handleNodeClick(node),
                admin: true,
                link: "#organizationCreation",
              },
              {
                name: "Organization Management",
                icon: "mdi-cogs",
                handler: (node) => this.handleNodeClick(node),
                admin: false,
                link: "#organizationManagement",
              },
            ],
          },
          {
            name: "Devices",
            icon: "mdi-cctv",
            admin: false,
            selectable: false,

            children: [
              {
                name: "Device Creation",
                icon: "mdi-plus",
                handler: (node) => this.handleNodeClick(node),
                admin: false,
                link: "#deviceCreation",
              },

              {
                name: "Device Creation - Multiple",
                icon: "mdi-plus-box-multiple-outline",
                handler: (node) => this.handleNodeClick(node),
                admin: false,
                link: "#deviceCreationMultiple",
              },
              {
                name: "Device Management",
                icon: "mdi-cogs",
                admin: false,
                children: [
                  {
                    name: "General",
                    icon: "mdi-cogs",
                    handler: (node) => this.handleNodeClick(node),
                    admin: false,
                    link: "#deviceManagement",
                  },
                  {
                    name: "Regenerating a Device's Key",
                    icon: "mdi-key",
                    handler: (node) => this.handleNodeClick(node),
                    admin: false,
                    link: "#deviceKeyRegen",
                  },
                  {
                    name: "Ownerships",
                    icon: "mdi-transit-connection",
                    admin: false,
                    children: [
                      {
                        name: "What is an Ownership",
                        icon: "mdi-help",
                        handler: (node) => this.handleNodeClick(node),
                        admin: true,
                        link: "#ownershipAbout",
                      },
                      {
                        name: "Ownership Creation",
                        icon: "mdi-plus",
                        handler: (node) => this.handleNodeClick(node),
                        admin: true,
                        link: "#ownershipCreation",
                      },
                      {
                        name: "Ownership Management",
                        icon: "mdi-cogs",
                        handler: (node) => this.handleNodeClick(node),
                        admin: false,
                        link: "#ownershipManagement",
                      },
                    ],
                  },
                  {
                    name: "Deployments",
                    icon: "mdi-map-marker-path",
                    admin: true,
                    selectable: false,
                    children: [
                      {
                        name: "What is a Deployment",
                        icon: "mdi-help",
                        handler: (node) => this.handleNodeClick(node),
                        admin: true,
                        link: "#deploymentAbout",
                      },
                      {
                        name: "Deployment Creation",
                        icon: "mdi-plus",
                        handler: (node) => this.handleNodeClick(node),
                        admin: true,
                        link: "#deploymentCreation",
                      },
                      {
                        name: "Deployment Management",
                        icon: "mdi-cogs",
                        handler: (node) => this.handleNodeClick(node),
                        admin: false,
                        link: "#deploymentManagement",
                      },
                    ],
                  },
                ],
              },
              {
                name: "Device Communication Spec",
                icon: "mdi-wifi",
                admin: false,
                handler: (node) => this.handleNodeClick(node),
                link: "#deviceComSpec",
              },
              {
                name: "Device Hubs and Chains",
                icon: "mdi-link",
                admin: false,
                handler: (node) => this.handleNodeClick(node),
                link: "#deviceHubAndChains",
              },
              {
                name: "Device Types",
                icon: "mdi-format-list-bulleted-type",
                admin: false,
                children: [
                  {
                    name: "What is a Device Type",
                    icon: "mdi-help",
                    handler: (node) => this.handleNodeClick(node),
                    admin: false,
                    link: "#deviceTypeAbout",
                  },
                  {
                    name: "Device Type Creation",
                    icon: "mdi-plus",
                    handler: (node) => this.handleNodeClick(node),
                    admin: true,
                    link: "#deviceTypeCreation",
                  },
                  {
                    name: "Device Type Management",
                    icon: "mdi-cogs",
                    handler: (node) => this.handleNodeClick(node),
                    admin: false,
                    link: "#deviceTypeManagement",
                  },
                  {
                    name: "Current Device Types",
                    icon: "mdi-format-list-bulleted-type",
                    handler: (node) => this.handleNodeClick(node),
                    admin: false,
                    link: "#currentDeviceTypes",
                  },
                  {
                    name: "Notifications",
                    icon: "mdi-transit-connection",
                    admin: false,
                    children: [
                      {
                        name: "UI Notifications",
                        icon: "mdi-application",
                        handler: (node) => this.handleNodeClick(node),
                        admin: true,
                        link: "#uiNotifications",
                      },
                      {
                        name: "Email Notifications",
                        icon: "mdi-email",
                        handler: (node) => this.handleNodeClick(node),
                        admin: true,
                        link: "#emailNotifications",
                      },
                    ],
                  },
                ],
              },
              {
                name: "Device Status's",
                icon: "mdi-link",
                admin: false,
                handler: (node) => this.handleNodeClick(node),
                link: "#deviceStatuses",
              },
              {
                name: "Device Map",
                icon: "mdi-link",
                admin: false,
                handler: (node) => this.handleNodeClick(node),
                link: "#deviceMap",
              },
            ],
          },
          {
            name: "Events",
            icon: "mdi-calendar-alert",
            admin: false,
            selectable: false,

            children: [
              {
                name: "Creating an Event (Device)",
                icon: "mdi-plus",
                admin: false,
                handler: (node) => this.handleNodeClick(node),
                link: "#deviceComSpec",
              },
              {
                name: "Viewing Event Data",
                icon: "mdi-eye",
                admin: false,
                selectable: false,
                children: [
                  {
                    name: "Event data (Via Website)",
                    icon: "mdi-earth",
                    admin: false,
                    handler: (node) => this.handleNodeClick(node),
                    link: "#eventDataWebsite",
                  },
                  {
                    name: "Event Data (Via API)",
                    icon: "mdi-api",
                    admin: true,
                    handler: (node) => this.handleNodeClick(node),
                    link: "#eventDataAPI",
                  },
                  {
                    name: "Event Images",
                    icon: "mdi-image",
                    admin: true,
                    handler: (node) => this.handleNodeClick(node),
                    link: "#eventImagesFromS3",
                  },
                ],
              },
              {
                name: "Creating metaData for an Event (Via API)",
                icon: "mdi-update",
                admin: true,
                handler: (node) => this.handleNodeClick(node),
                link: "#eventMetaData",
              },
            ],
          },
          {
            name: "Users",
            icon: "mdi-account-group",
            admin: false,
            selectable: false,

            children: [
              {
                name: "Creating a User",
                icon: "mdi-plus",
                admin: false,
                handler: (node) => this.handleNodeClick(node),
                link: "#userCreation",
              },
              {
                name: "Giving User Roles",
                icon: "mdi-chevron-triple-up",
                admin: false,
                handler: (node) => this.handleNodeClick(node),
                link: "#userRoles",
              },
            ],
          },
          {
            name: "Notifications",
            icon: "mdi-alert",
            admin: false,
            selectable: false,

            children: [
              {
                name: "Types of Notifications",
                icon: "mdi-plus",
                admin: false,
                handler: (node) => this.handleNodeClick(node),
                link: "#typesOfNotifications",
              },
              {
                name: "Managing your notification Settings",
                icon: "mdi-cogs",
                admin: false,
                handler: (node) => this.handleNodeClick(node),
                link: "#userNotificationManagement",
              },
            ],
          },
          {
            name: "AWS",
            icon: "mdi-aws",
            admin: true,
            selectable: false,

            children: [
              {
                name: "CLI Installation",
                icon: "mdi-download",
                admin: true,
                handler: (node) => this.handleNodeClick(node),
                link: "#awsInstallation",
              },
            ],
          },
          {
            name: "Backups",
            icon: "mdi-cloud-upload",
            admin: true,
            selectable: false,

            children: [
              {
                name: "CLI Installation",
                icon: "mdi-download",
                admin: true,
                handler: (node) => this.handleNodeClick(node),
                link: "#awsInstallation",
              },
            ],
          },
        ];
      },
      items: function () {
        return [
          {
            name: "Devices",
            icon: "mdi-cctv",
            admin: false,
            selectable: false,
            children: [
              {
                name: "Device Creation",
                icon: "mdi-plus",
                admin: false,
                handler: (node) => this.handleNodeClick(node),
                link: "#deviceCreation",
              },
              {
                name: "Device Management",
                icon: "mdi-cogs",
                admin: false,
                selectable: true,
                link: "#deviceManagement",
              },
              {
                name: "Device Communication Spec",
                icon: "mdi-wifi",
                admin: false,
                selectable: true,
                link: "#deviceComSpec",
              },
            ],
          },
          {
            name: "Events",
            icon: "mdi-calendar-alert",
            selectable: false,

            admin: false,
            children: [
              {
                name: "Creating an Event (Device)",
                icon: "mdi-plus",
                admin: false,
                selectable: true,
                link: "#deviceComSpec",
              },
              {
                name: "Viewing Event Data",
                icon: "mdi-eye",
                admin: false,
                selectable: false,
                children: [
                  {
                    name: "Event data (Via Website)",
                    icon: "mdi-earth",
                    admin: false,
                    selectable: true,
                    link: "#eventDataWebsite",
                  },
                ],
              },
            ],
          },
        ];
      },
    },
    watch: {},
    data: () => ({
      drawer: null,
      apiUrlSelection: true,
      // Scroll Options
      options: {
        duration: 450,
        offset: 0,
        easing: "easeInOutCubic",
      },
      // Table of Contents
      open: [],
      tree: [],

      selected: null,

      // Devices
      eventDataFormat: {
        id: 1,
        k: "Device Key",
        type: "trigger",
        sessions: 1,
        triggers: 1,
        version: 1,
        battery: 1.3,
        temp: 12.2,
        message: "String",
        time: "UTC Time Stamp",
        image: "Base64 Encoded file (Doesnt need to be an image)",
        data: "Raw data to be uploaded to S3 (Cannot be used if the image field is also being used)",
        ext: "Extention for file. Default: jpg (Doesnt need to be an image)",
        packet_total:
          "This is the total number of Packets that will be sent to build either the Image or the Data",
        packet_num:
          "This is the current packet index (if v = cp then packet_num starts at 1, otherwise packet_num starts at 0)",
        partialData: "This is a partial piece of the data that is being sent",
        p_group_uid:
          "This is a unique ID assigned to a packet group, that way the server knows what packets relate to what event",
        v: "This is the version the event is running on. By default v is set to 'cp', but the other option to use is 'f'",
      },
      // Events
      eventMetaDataFormat: {
        id: 1,
        exampleData1: "This is example data",
        exampleData2:
          "Both exampleData1 and exampleData2, will be added into the Meta Data field",
      },
    }),
    mounted() {},
    methods: {
      linkWithGoogle() {
        this.$store.dispatch("auth/linkWithGoogle");
      },
      handleNodeClick(node) {
        location.hash = "";
        location.hash = node.link;
      },
    },
  };
</script>
